<template>
    <div>
        <template v-if="isPageAllowed">
            <div class="filter-bar mb20">
                <el-row>
                    <el-col :span="2">
                        <el-button type="primary" v-if="pageFuncNames.includes('new_task')"
                        v-matomo="{behaviorCategory: '重抓数据', event: '点击',  name: '新建任务' }"
                        @click="showAddPage">新建任务</el-button>
                    </el-col>
                    <el-col :span="21">
                        <el-form :inline="true" @submit.native.prevent="submitSearch">

                        </el-form>
                        <!--<span v-if="refreshLoading" class="text-color-gray absolute " style="right: 0;bottom: -10px;">自动刷新中...</span>-->
                    </el-col>
                </el-row>
            </div>
            <div class="data-list">
                <jt-table
                    v-loading="dataLoading"
                    :data="dataList"
                    stripe
                    :header-cell-style="{background:'#e8eaec',color:'#333'}"
                    :default-sort = "{prop: 'log_time', order: 'descending'}"
                    style="width: 100%">
                    <el-table-column
                        prop="id"
                        label="ID"
                        align="center"
                        min-width="100">
                    </el-table-column>
                    <el-table-column
                        prop="plat"
                        label="媒体"
                        align="center"
                        min-width="100">
                        <template slot-scope="scope">
                            <span>{{scope.row.plat||'--'}} </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="content_type_text"
                        label="抓取内容"
                        align="center"
                        min-width="100"/>

                    <el-table-column
                        prop="task_detail"
                        label="任务详情"
                        align="left"
                        width="250">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" placement="top">
                                <!-- // {{}}会将数据解释为普通文本，而非 HTML 代码。 -->
                                <div v-html="scope.row.task_detail" slot="content" style="max-width: 500px;"></div>
                                <div class="ellipsis">{{scope.row.task_detail|maxTextLen(35)}}</div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="range"
                        label="抓取时段"
                        align="center"
                        width="150">
                        <template slot-scope="scope">
                            <p class="nowrap" v-if="scope.row.content_type ==='0'">
                                <span>{{scope.row.start||''}} - {{scope.row.end||''}} </span>
                            </p>
                            <p v-else>-</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="status_text"
                        label="状态"
                        align="center"
                        min-width="100">
                        <template slot="header" slot-scope="scope">
                            <span>状态</span>
                            <div class="count-time inline-block">
                                <!--<el-progress v-if="!dataLoading" :width="20" color="red" :format="countText" :stroke-width="2" type="circle" :percentage="(refreshCountdown/5)*100"></el-progress>-->
                                <el-progress v-if="refreshTimer" :width="20" :format="countText" :stroke-width="2" type="circle" :percentage="percentage"></el-progress>
                            </div>
                        </template>
                        <template slot-scope="scope">
                            <!-- 1-抓取中,2-成功 3-部分失败 4-全部失败 -->
                            <span v-if="scope.row.status=='2'" class="text-color-success">{{scope.row.status_text||''}}</span>
                            <template v-else-if="scope.row.status=='3'||scope.row.status=='4'" >
                                <el-popover
                                    placement="right"
                                    title="失败信息"
                                    width="250"
                                    trigger="hover">
                                    <span slot="reference" class="text-color-error pointer">
                                        {{scope.row.status_text||''}}
                                        <i class="el-icon-warning-outline"></i>
                                    </span>
                                    <p v-if="(scope.row.err_info||[]).length<=0">暂无数据</p>
                                    <div v-else class="popover-info" >
                                        <p class="m10" v-for="item in scope.row.err_info" :key="item">{{item}}</p>
                                    </div>
                                </el-popover>


                            </template>
                            <span v-else>{{scope.row.status_text||''}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="finish_time"
                        label="抓取结束时间"
                        align="center"
                        min-width="100">
                        <template slot-scope="scope">
                            <p class="">{{scope.row.finish_time.split(' ')[0]}}</p>
                            <p class="">{{scope.row.finish_time.split(' ')[1]}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="total_time"
                        label="耗时"
                        align="center"
                        min-width="100">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="抓取人"
                        align="center"
                        min-width="100">
                    </el-table-column>
                    <el-table-column
                        prop="create_time"
                        label="创建时间"
                        align="center"
                        min-width="100">
                        <template slot-scope="scope">
                            <p class="">{{scope.row.create_time.split(' ')[0]}}</p>
                            <p class="">{{scope.row.create_time.split(' ')[1]}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="status"
                        label="操作"
                        align="center"
                        fixed="right"
                        width="175">
                        <template slot-scope="scope">
                            <template v-if="pageFuncNames.includes('new_task')">
                                <el-link type="primary" class="ml6 mr6"
                                v-matomo="{behaviorCategory: '重抓数据', event: '点击',  name: '列表(复制任务)' }"
                                @click="copyTask(scope.row)">复制任务</el-link>
                                <el-link type="primary" :disabled="scope.row.status!='3'&&scope.row.status!='4'" class="ml6 mr6"
                                v-matomo="{behaviorCategory: '重抓数据', event: '点击',  name: '列表(重抓失败项)' }"
                                @click="retryTask(scope.row)">重抓失败项</el-link>
                            </template>
                            <span v-else>--</span>
                        </template>
                    </el-table-column>
                </jt-table>
            </div>
            <div class="page-bar tac mt20">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryData.pn"
                    :page-sizes="[30,50,100]"
                    :pager-count="5"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCnt">
                </el-pagination>
            </div>

            <RetryTaskModal ref="retryTaskModal" :func="pageFunc" :pageFuncNames="pageFuncNames" :modal-data="actionData" :plat-list="allowedPlatList" :action="actionType" @update="updateDataList"/>

        </template>
        <template v-else>
            <NoPermissionInfo>
                <p>此页面为系统所有操作的操作日志查看页面。</p>
            </NoPermissionInfo>
        </template>
    </div>
</template>

<script>
    import {pageMixin} from '../mixins/pageMixin';
    import NoPermissionInfo from '@/components/noPermissionInfo';
    import RetryTaskModal from './modal/retryTaskModal';
    import API from '@/api/systemTool.js';

    export default {
        name: "Retry",
        mixins: [pageMixin],
        components:{
            NoPermissionInfo,
            RetryTaskModal,
        },
        data() {
            return {
                dataLoading: false,
                queryData: {
                    pn: 1,
                    rn: 30,
                },
                tempQuery: {
                },
                dataList: [],
                totalCnt: 0,
                actionData:{
                    title:'',
                },
                actionType:'',
                refreshLoading:false,
                refreshTimer:null,
                refreshCountdown:0,
                refreshInterval:5,   //  刷新频率/秒
            }
        },
        computed:{
            percentage(){
                if(this.refreshCountdown<=0) return 100;
                if(this.refreshCountdown>=this.refreshInterval) return 0;
                return ((this.refreshInterval-this.refreshCountdown)/this.refreshInterval)*100;
            }
        },
        filters:{
            maxTextLen(str,maxLen){
                if(str.length<=maxLen){
                    return str;
                }else{
                    return str.substring(0,maxLen)+'...';
                }
            }
        },
        created() {
            this.submitSearch();
        },
        mounted(){
        },
        methods: {
            submitSearch(){
                this.queryData.pn = 1;
                this.getDataList();
            },
            updateDataList(){
                // this.clearAutoRefresh();
                this.getDataList();
            },
            getDataList() {
                this.clearAutoRefresh();
                this.dataLoading = true;
                API.getDataList({
                    current_uid: this.queryData.current_uid,
                    user_id: this.queryData.user_id,
                    module_id: this.queryData.module_id,
                    log_type: this.queryData.log_type,
                    result: this.queryData.result,
                    operation_object: this.queryData.operation_object,
                    range_time: this.queryData.range_time,
                    order_by:this.queryData.order_by,
                    order_type:this.queryData.order_type,
                    pn:this.queryData.pn,
                    rn:this.queryData.rn,
                }).then(res => {
                    let resData = res.data || {};
                    this.dataLoading = false;
                    let dataList = resData.list||[];

                    this.dataList = dataList.map(v=> {
                        return {
                            ...v,
                            content_type_text: v.content_type ==='0'?'效果数据':'基础数据',
                        }
                    });
                    this.totalCnt = resData.totalCnt;

                    if(dataList.some(item=>item.status=='1')){
                        this.refreshCountdown = this.refreshInterval;
                        this.autoRefresh();
                    }
                }, (err) => {
                    console.log('getDataList error', err);
                    this.dataList = [];
                    this.dataLoading = false;
                    this.totalCnt = 0;
                });
            },
            handleSizeChange(val) {
                this.queryData.rn= val;
                this.getDataList();
            },
            handleCurrentChange(val) {
                this.queryData.pn= val;
                this.getDataList();
            },
            showAddPage(){
                console.log('showAddPage');
                this.actionData = {};
                this.actionType = 'add';
                this.$refs.retryTaskModal.showModal();
            },
            retryTask(row){
                console.log('retryTask',row);
                this.actionType = 'retry';

                this.actionData.content_type = row.content_type;
                this.actionData.choice_type = row.choice_type;
                this.actionData.retry_type = row.retry_type;
                this.actionData.detail_list = row.detail_list||[];
                this.actionData.detail_list_for_copy = row.detail_list_for_copy||[];
                this.actionData.err_list = row.err_list||[];
                this.actionData.err_info = row.err_info;
                this.actionData.id = row.id;
                this.actionData.plat_id = row.plat_id;
                this.actionData.start = row.start;
                this.actionData.end = row.end;


                this.$refs.retryTaskModal.showModal();
            },
            copyTask(row){
                console.log('copyTask',row);
                this.actionType = 'copy';

                this.actionData.content_type = row.content_type;
                this.actionData.choice_type = row.choice_type;
                this.actionData.retry_type = row.retry_type;
                this.actionData.detail_list = row.detail_list||[];
                this.actionData.detail_list_for_copy = row.detail_list_for_copy||[];
                this.actionData.err_account_list = row.err_account_list||[];
                this.actionData.err_info = row.err_info;
                this.actionData.id = row.id;
                this.actionData.plat_id = row.plat_id;
                this.actionData.start = row.start;
                this.actionData.end = row.end;


                this.$refs.retryTaskModal.showModal();
            },
            autoRefresh(){
                /*1-抓取中,2-成功 3-部分失败 4-全部失败*/
                let rowList = this.dataList.filter(item=>item.status=='1');

                if(rowList.length<=0){
                    clearTimeout(this.refreshTimer);
                    this.refreshTimer = null;
                    return this.refreshCountdown = 0;
                }
                this.refreshTimer = setTimeout(()=>{
                    console.log('this.refreshCountdown',this.refreshCountdown);
                    if(this.refreshCountdown>0){
                        this.refreshCountdown--;
                        this.autoRefresh();
                    }else{
                        this.refreshStatus();
                    }
                },1000)
            },
            refreshStatus(){
                console.log('refreshStatus');
                /*1-抓取中,2-成功 3-部分失败 4-全部失败*/
                let rowList = this.dataList.filter(item=>item.status=='1');

                if(rowList.length<=0){
                    clearTimeout(this.refreshTimer);
                    this.refreshTimer = null;
                    return this.refreshCountdown = 0;
                }
                this.refreshLoading = true;
                API.getRetryStatus({
                    ids:rowList.map(item=>item.id).join(','),
                }).then(res => {
                    console.log('getRetryStatus',res);
                    let resData = res.data||[];
                    resData.forEach(item=>{
                        let actionItem = this.dataList.find(inner=>inner.id==item.id);
                        if(actionItem){
                            /* 更新 状态 */
                            actionItem.status= item.status;
                            actionItem.status_text= item.status_text;

                            if(item.status!='1'){
                                /* 更新 抓取结束时间、耗时*/
                                actionItem.finish_time = item.finish_time;
                                actionItem.total_time = item.total_time;
                            }
                            if(item.status=='3'||item.status=='4'){
                                /* 更新 失败详情、err_list（重抓失败项）  */
                                actionItem.err_info = item.err_info;
                                actionItem.err_list = item.err_list;
                            }
                        }
                    });
                    this.refreshCountdown = this.refreshInterval;
                    this.autoRefresh();
                    this.refreshLoading = false;
                }, (err) => {
                    console.log('getRetryStatus err',err);
                    this.refreshCountdown = this.refreshInterval;
                    this.autoRefresh();
                    this.refreshLoading = false;
                });
            },
            clearAutoRefresh(){
                clearTimeout(this.refreshTimer);
                this.refreshTimer = null;
            },
            countText(){
                let num = this.refreshCountdown;
                if(num>=this.refreshInterval){
                    return '';
                }else if(num<=0){
                    return '1'
                }else{
                    return ''+(num+1);
                }
            },
        },
        beforeDestroy(){
            console.log('retry list beforeDestroy');
            this.clearAutoRefresh();
        }
    }
</script>

<style lang="scss" scoped>
    .popover-info {
        max-height: 300px;
        overflow: auto;
    }
    .count-time{
        display: inline-block;
        width: 20px;
        height: 20px;
        position: relative;
        top: 6px;
        right: -5px;
        ::v-deep .el-progress__text{
            font-size: 12px!important;
        }
    }
</style>
